import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@mui/material";
// import { useAuth } from "../../Auth/Auth";
import {apiHeader} from '../../../utils/apiHeader'
import axios from "axios";
import { globalConfig } from "../../../config/config";

//const querystring = require("querystring");
const CreateContent = () => {
  const [contentFileTypes, setContentFileTypes] = useState([]);
  const [contentInputSourceTypes, setContentInputSourceTypes] = useState([]);
  const [message, setMessage] = useState("");
//   const {token,userMetadata}=useAuth()
	const token = globalConfig.hardcoded_header;
//   const history = useHistory();
  const [state, setState] = useState({
    contentId: 0,
    contentImageFile: "",
    contentImageFileType: 0,
    contentTitle: "",
    contentName: "",
    inputSourceValueCode: 0,
    securityContextId: 0,
    createUser: 0,
    createDate: new Date().toISOString(),
    lastUpdateUser: 0,
    lastUpdateDate: new Date().toISOString(),
    contentCdata: "",
    contentBdata: "",
    deleteFlag: 0,
    contentTypes: "",
    proofingStatusCode: 0,
    proofingStatusMsg: "",
    partNumber: "",
    recordCount: 0,
    filesize: 0,
    uploadFileType: 0,
    platformEntryPoint: "",
    serviceEntryPoint: "",
    callbackEntryPoint: "",
    httpMethod: "",
    rate: 0,
    billingMethod: "",
    authKey: "",
    apiKey: "",
    apiSecret: "",
    version: "",
  });

  function handleChange(event) {
    console.log(event);
    var target = event.target;
    console.log(target.id + ":" + target.value);
    setState({
      ...state,
      [target.id]: isNaN(target.value) ? target.value : parseInt(target.value),
    });

    console.log(state);
  }
  function handleSubmit(event) {
    event.preventDefault();
    console.log("handling submit");

    var url = `${globalConfig.apiDatahubUrl}/contents`;
    var idUrl = `${globalConfig.apiMainUrl}/next-id-generator/get-next/contents/contentId`;

    axios.get(idUrl,  apiHeader(token)).then((response) => {
      state.contentId = response.data["nextId"];

      //console.log("new category id = " + JSON.stringifyt(this.state.contentCategoriesObject.contentCategoryId));

      console.log("request object = " + JSON.stringify(state));
      axios
        .post(url, state,  apiHeader(token))
        .then((response2) => {
          console.log("response.data");
          console.log(response2.status + ":" + response2.data.contentId);
          // && response2.data.contentFacadeId === this.state.contentFacadeId
          if (response2.status === 200) {
            setMessage("Success");
          } else {
            setMessage("Failed");
          }
          console.log(message);
          //
          event.preventDefault();
          //response.send(this.message);
          setTimeout(() => {
            history.goBack();
          }, 1500);
        })
        .catch((err) => {
          console.log("error - " + err);
        });
      console.log("message info - " + message);
      // setState({ ...state, contentTitle: "", contentName: "" });

     
    });

    //   console.log("SetState Message info-"+contentFacadeTypeId);
    //   console.log("SetState Message info-"+contentFacadeName);
  }
  function handleRest() {
    setState({
      contentTitle: "",
      contentName: "",
    });
  }

  useEffect(() => {
    handleOnLoad();
  }, []);
  // componentDidMount()
  // {
  // 	this.handleOnLoad();
  // }

  const handleOnLoad = () => {
    // axios.get(`http://os-dev.origosoftware.com:3000/contents/`).then((res) => {
    //   const contents = res.data;
    //   console.log(contents);
    //   setState({ ...state, contents: contents });
    //   console.log(res.data[0]);
    // });

    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_FILE_TYPE`,
         apiHeader(token)
      )
      .then((res) => {
        const contentFileTypes = res.data;
        console.log(contentFileTypes);
        setContentFileTypes(contentFileTypes);
      })
      .catch((x) => {
      });

    axios
      .get(
        `${globalConfig.systemCodesUrl}/CONTENT_INPUT_SOURCE_TYPE`,
         apiHeader(token)
      )
      .then((res) => {
        const contentInputSourceTypes = res.data;
        console.log(contentInputSourceTypes);
        setContentInputSourceTypes(contentInputSourceTypes);
      })
      .catch((x) => {
      });
  };

  return (
    <form>
		<div style={{display:"flex",justifyContent:"space-between"}}>
			<h4>Create Content</h4>
			
			<Link to="/breeze/list-content">
				<Button variant="contained">
					Go Back
				</Button>
			</Link>
		</div>
		<hr/>

      <div className="container-fluid">
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Name">
            Name
          </label>
          <input
            className="form-control input-big col-sm-8"
            id="contentName"
            value={state.contentName}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Title">
            Title
          </label>
          <input
            className="form-control input-big col-sm-8"
            id="contentTitle"
            value={state.contentTitle}
            onChange={handleChange}
          />
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Input Source">
            Input Source
          </label>
          <select
            className="form-control input-big col-sm-8"
            id="inputSourceValueCode"
            value={state.inputSourceValueCode}
            onChange={handleChange}
          >
            {/* <option value="#{ombNeoServerForm.contentInputSourcesList}" /> */}
            <option value={0}>Select Input Source Type</option>
            {contentInputSourceTypes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content File Type">
            Content File Type
          </label>
          <select
            className="form-control input-big col-sm-8"
            id="contentImageFileType"
            value={state.contentImageFileType}
            onChange={handleChange}
          >
            <option value={0}>Select File Type</option>
            {contentFileTypes.map(
              ({ systemCodeId, systemCodeValueValue, systemCodeValueId }) => (
                <option key={systemCodeValueId} value={systemCodeValueId}>
                  {systemCodeValueValue}{" "}
                </option>
              )
            )}
          </select>
        </div>
        <div className="form-group row">
          <label className="ContentTitle col-sm-2" value="Content File">
            Content File
          </label>
          <input
            className="form-control input-big col-sm-8"
            id="contentImageFile"
            value={state.contentImageFile}
            onChange={handleChange}
          />
        </div>
        <hr />
        <div className="form-group row ml-2">
          <button className="btn btn-primary" value="Clear" onClick={handleRest}>
            Clear
          </button>
          &nbsp;
          <button className="btn btn-success" value="Create" onClick={handleSubmit}>
            Create
          </button>
        </div>
      </div>
    </form>
  );
};

export default CreateContent;
